export default __webpack_public_path__ + "static/media/11n.28dfc61b.svg";